var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x8A\xE1\x85\xB5\xE1\x84\x90\xE1\x85\xB5 1",
    clipPath: "url(#clip0_1736_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#1D2087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.23784 14.4299C7.91554 14.4297 7.59848 14.3483 7.31591 14.1933C7.03333 14.0383 6.79432 13.8146 6.62091 13.543C6.44751 13.2713 6.34528 12.9603 6.32366 12.6388C6.30203 12.3172 6.36171 11.9953 6.49719 11.7029C6.63266 11.4105 6.83958 11.1568 7.09886 10.9654C7.35814 10.7739 7.66144 10.6508 7.98081 10.6074C8.30017 10.564 8.62532 10.6017 8.92629 10.717C9.22725 10.8324 9.49435 11.0216 9.70295 11.2673L10.4229 10.5473C10.0352 10.1147 9.52788 9.80671 8.96514 9.66239C8.40239 9.51807 7.80948 9.54386 7.26139 9.73649C6.71329 9.92913 6.23463 10.28 5.88591 10.7446C5.53719 11.2093 5.33408 11.7669 5.30226 12.347C5.27044 12.9271 5.41135 13.5036 5.70715 14.0036C6.00296 14.5036 6.44038 14.9047 6.96412 15.1561C7.48786 15.4075 8.07439 15.498 8.64954 15.4161C9.2247 15.3342 9.76266 15.0836 10.1954 14.6959C10.2665 14.6321 10.3345 14.5649 10.3994 14.4944L9.67939 13.7744C9.49977 13.9802 9.2782 14.1451 9.02957 14.2582C8.78093 14.3713 8.51098 14.4298 8.23784 14.4299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0616 9.57031H10.8252V15.4321H12.0616V9.57031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.5333 9.57031H17.2969V15.4321H18.5333V9.57031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.1968 14.2074V10.7657H16.2019V9.70255H15.1968V8.06055L13.9599 8.6701V9.70255H12.9668V10.7657H13.9606V14.2074C13.9606 14.2074 13.9828 15.4337 15.1859 15.4337C16.389 15.4337 16.659 14.8423 16.659 14.1954H15.6877C15.6877 14.1954 15.4612 14.4628 15.1968 14.2074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.6517 7.24703C15.9184 7.24703 17.0961 7.84147 18.0721 8.85747H19.6999C18.3808 7.28414 16.6059 6.31836 14.6517 6.31836C12.6975 6.31836 10.9221 7.28414 9.60303 8.85747H11.2308C12.2061 7.84192 13.3837 7.24703 14.6517 7.24703Z",
    fill: "#E50012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.8105f377d7aafc59b649a0a60ef562d3.svg";
export { ForwardRef as ReactComponent };